import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4d71cea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-headers" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "table-body" }
const _hoisted_4 = {
  key: 0,
  class: "table-loading"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "table-row-expanded-wrapper"
}
const _hoisted_8 = { class: "table-row-expanded" }
const _hoisted_9 = {
  key: 0,
  class: "table-row-expanded-wrapper"
}
const _hoisted_10 = { class: "table-row-responsive-expanded" }
const _hoisted_11 = { class: "mr-2 flex-shrink-0" }
const _hoisted_12 = { class: "responsive-expanded-line__content" }
const _hoisted_13 = { class: "italic text-gray-700" }
const _hoisted_14 = {
  key: 1,
  class: "table-empty"
}

import {
  computed,
  reactive,
  ref,
} from 'vue';
import { Column, DataFunction, Row, SortOrder, TableViewComponentParams } from '../types';
import { useResponsive, UseResponsiveParams } from './hooks/use-responsive';
import { useResponsiveExpanded } from './hooks/use-responsive-expanded';
import { useSelectable } from './hooks/use-selectable';
import { RESPONSIVE_COLUMN_WIDTH, SELECT_COLUMN_WIDTH, EXPANDED_COLUMN_WIDTH } from './constants';
import { useRefElementWidth } from '@/hooks/use-ref-element-width';
import Checkbox from '@ui-kit/inputs/checkbox/Checkbox.vue';
import _ from 'lodash';
import TransitionExpanded from '../../transition/TransitionExpanded.vue';
import ShowMoreLine from '../../show-more/ShowMoreLine.vue';

interface RenderColumn {
  name: string;
  data: DataFunction;
}
interface RenderRow {
  row: Row;
  data: Record<string, any>;
  responsiveExpanded: boolean;
  expanded: boolean;
  selected: boolean;
}

interface Props {
  params: TableViewComponentParams;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TableView',
  props: {
    params: null
  },
  setup(__props: any) {

const props = __props as {
  params: TableViewComponentParams;
}



const tableRef = ref<HTMLElement>();
const tableWidth = useRefElementWidth(tableRef);

// TODO: check other variants
const {widthColumns, showResponsive} = useResponsive(reactive({
  columns: computed(() => props.params.columns),
  tableWidth: computed(() => tableWidth.value),
  selectable: computed(() => props.params.selectable),
  expandable: computed(() => props.params.expandable),
}) as UseResponsiveParams<Column>);

const visibleColumns = computed(() => {
  return widthColumns.value.filter(({width}) => width > 0);
});
const responsiveHiddenColumns = computed(() => {
  return widthColumns.value.filter(({width}) => width === 0);
});

const { toggleResponsive, responsiveExpanded } = useResponsiveExpanded();
const { isAllSelected, selectedIds, toggleSelect, toggleAllRows } = useSelectable({
  rows: computed(() => props.params.rows),
});

const expanded = ref<any>();
function toggleExpanded(row: Row) {
  if (expanded.value === row.id) {
    expanded.value = undefined;
  } else {
    expanded.value = row.id
  }
}

const renderColumn = computed<RenderColumn[]>(() => {
  return props.params.columns.map((col) => {
    let data: DataFunction;
    const colData = col.data;
    if (typeof colData === 'function'){
      data = colData;
    } else if (colData === undefined){
      data = () => '';
    } else {
      data = (row) => _.get(row, colData);
    }

    return {
      name: col.name,
      data,
    }
  })
});
const renderRows = computed<RenderRow[]>(() => {
  return props.params.rows.map((row) => {
    const data = renderColumn.value.reduce((res, col) => {
      res[col.name] = col.data(row);
      return res;
    }, {} as RenderRow['data']);

    return {
      row,
      data,
      responsiveExpanded: showResponsive && responsiveExpanded.value === row.id,
      expanded: !!props.params.expandable && expanded.value === row.id,
      selected: !!props.params.selectable && selectedIds.value.includes(row.id),
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "table-view",
    ref_key: "tableRef",
    ref: tableRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.params.expandable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "table-header",
            style: _normalizeStyle({width: _unref(EXPANDED_COLUMN_WIDTH) + 'px'})
          }, null, 4))
        : _createCommentVNode("", true),
      (_unref(showResponsive))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "table-header",
            style: _normalizeStyle({width: _unref(RESPONSIVE_COLUMN_WIDTH) + 'px'})
          }, null, 4))
        : _createCommentVNode("", true),
      (__props.params.selectable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "table-header justify-center",
            style: _normalizeStyle({width: _unref(SELECT_COLUMN_WIDTH) + 'px'})
          }, [
            _createVNode(Checkbox, {
              "model-value": _unref(isAllSelected),
              "onUpdate:modelValue": _unref(toggleAllRows)
            }, null, 8, ["model-value", "onUpdate:modelValue"])
          ], 4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleColumns), (column) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["table-header", [column.commonClasses || '', column.headerClasses || '']]),
          key: column.name,
          style: _normalizeStyle({width: column.width + 'px'})
        }, [
          _renderSlot(_ctx.$slots, `header-${column.name}`, { column: column }, () => [
            _createTextVNode(_toDisplayString(column.title), 1)
          ]),
          (column.sort !== undefined)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "sort-toggle-button",
                onClick: ($event: any) => (_ctx.$emit('toggleSort', column))
              }, [
                (column.sort === _unref(SortOrder).ASC)
                  ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 0,
                      icon: "sort-up"
                    }))
                  : (column.sort === _unref(SortOrder).DESC)
                    ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                        key: 1,
                        icon: "sort-down"
                      }))
                    : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                        key: 2,
                        icon: "sort"
                      }))
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ], 6))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.params.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderRows), (row) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: row.row.id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["table-row", {selected: row.selected}])
          }, [
            (__props.params.expandable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "table-cell justify-center",
                  style: _normalizeStyle({width: _unref(EXPANDED_COLUMN_WIDTH) + 'px'})
                }, [
                  _createElementVNode("button", {
                    class: "responsive-button",
                    onClick: ($event: any) => (toggleExpanded(row.row))
                  }, [
                    (row.expanded)
                      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 0,
                          icon: "caret-up"
                        }))
                      : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 1,
                          icon: "caret-down"
                        }))
                  ], 8, _hoisted_5)
                ], 4))
              : _createCommentVNode("", true),
            (_unref(showResponsive))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "table-cell justify-center",
                  style: _normalizeStyle({width: _unref(RESPONSIVE_COLUMN_WIDTH) + 'px'})
                }, [
                  _createElementVNode("button", {
                    class: "responsive-button",
                    onClick: ($event: any) => (_unref(toggleResponsive)(row.row))
                  }, [
                    (row.responsiveExpanded)
                      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 0,
                          icon: "caret-up"
                        }))
                      : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 1,
                          icon: "caret-down"
                        }))
                  ], 8, _hoisted_6)
                ], 4))
              : _createCommentVNode("", true),
            (__props.params.selectable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "table-cell justify-center",
                  style: _normalizeStyle({width: _unref(SELECT_COLUMN_WIDTH) + 'px'})
                }, [
                  _createVNode(Checkbox, {
                    "model-value": row.selected,
                    "onUpdate:modelValue": ($event: any) => (_unref(toggleSelect)(row.row))
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ], 4))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleColumns), (column) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["table-cell", [column.commonClasses || '', column.cellClasses || '']]),
                key: column.name,
                style: _normalizeStyle({width: column.width + 'px'})
              }, [
                _renderSlot(_ctx.$slots, `cell-${column.name}`, {
                  row: row.row,
                  column: column,
                  value: row.data[column.name]
                }, () => [
                  _createVNode(ShowMoreLine, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.data[column.name]), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 6))
            }), 128))
          ], 2),
          _createVNode(TransitionExpanded, null, {
            default: _withCtx(() => [
              (__props.params.expandable && row.expanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "expanded", {
                        row: row.row
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          _createVNode(TransitionExpanded, null, {
            default: _withCtx(() => [
              (_unref(showResponsive) && row.responsiveExpanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _renderSlot(_ctx.$slots, "responsive-expanded", {
                        row: row,
                        columns: _unref(responsiveHiddenColumns)
                      }, () => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(responsiveHiddenColumns), (column) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: column.name,
                            class: "responsive-expanded-line"
                          }, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(column.title) + ":", 1),
                            _createElementVNode("div", _hoisted_12, [
                              _renderSlot(_ctx.$slots, `cell-${column.name}`, {
                                row: row.row,
                                column: column,
                                value: row.data[column.name]
                              }, () => [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(row.data[column.name]), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ], 64))
      }), 128)),
      (_unref(renderRows).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('components.table.no-records')), 1))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})